import IconComment from '@apollo/icons/default/IconComment.svg';
import IconOverflow from '@apollo/icons/default/IconOverflow.svg';
import { Button } from '@apollo/space-kit/Button';
import { colors } from '@apollo/space-kit/colors';
import classnames from 'classnames';
import React from 'react';

import { PlainHtmlButton } from 'src/components/common/plainHtmlButton/PlainHtmlButton';

export const ProposalCommentButton = ({
  replyCount,
  isMultiThreadLine,
  className,
  onClick,
  ...rest
}: {
  replyCount?: number;
  isMultiThreadLine?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement> | undefined;
} & Omit<
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >,
  'ref' | 'color'
>) => {
  if (!replyCount) {
    return (
      <Button
        size="small"
        aria-label="Comment on coordinate"
        color={colors.blue.base}
        onClick={onClick}
        className={classnames('size-6 min-w-0', className)}
        icon={<IconComment />}
        {...rest}
      />
    );
  }

  return (
    <PlainHtmlButton
      className={classnames(
        'focus-visible:focus-ring flex h-5 w-9 items-center justify-center rounded-r-full border border-blue-darker bg-blue pr-1 text-sm font-semibold leading-5 text-inverted',
        className,
      )}
      onClick={onClick}
      {...rest}
    >
      {isMultiThreadLine ? (
        <IconOverflow className="text-inverted" />
      ) : replyCount < 100 ? (
        replyCount
      ) : (
        '99+'
      )}
    </PlainHtmlButton>
  );
};
